import { legacy } from '@/shared/api/client';
import type { Lead, PaginatedResponse } from '@/shared/types';

function headers(idPassbook: string) {
  return { headers: { 'X-Passbook-Id': idPassbook } };
}

/**
 * Busca por CPF para o upgrade/downgrade manual de tier. Versão simplificada
 * do lookup do Operador (src/features/operator/api/operator-search.ts) — só
 * `/usersPaginate`, sem a variante multi-loja — para não importar internals
 * de outra feature (ver docs/architecture.md, regra de fronteira entre
 * features). Se a L'Occitane precisar de multi-loja aqui, replicar
 * `isMultiStoreLeads`/`usersPaginateMulti` como no Operador.
 */
export async function searchLeadByCpf(idPassbook: string, cpf: string): Promise<Lead | null> {
  const digits = cpf.replace(/\D/g, '');
  const res = await legacy.post<PaginatedResponse<Lead>>(
    '/usersPaginate',
    {
      id_passbook: idPassbook,
      role: ['Member', 'Employee'],
      length: 1,
      skip: 0,
      search: { value: digits || cpf },
      order: [{ column: 0, dir: 'desc' }],
      columns: [{ data: 'updated' }, { data: 'profile.uniqueId' }],
    },
    headers(idPassbook),
  );
  const rows = Array.isArray(res?.data) ? res.data : [];
  return rows[0] ?? null;
}

/** Upgrade/downgrade manual — PUT /user/:id/tier-override. */
export async function setTierOverride(
  idPassbook: string,
  userId: string,
  level: string,
  reason: string,
): Promise<void> {
  await legacy.put<{ ok: boolean }>(
    `/user/${userId}/tier-override`,
    { id_passbook: idPassbook, level, reason },
    headers(idPassbook),
  );
}

/** Volta a calcular o tier automaticamente pelo saldo — DELETE /user/:id/tier-override. */
export async function clearTierOverride(idPassbook: string, userId: string): Promise<void> {
  await legacy.delete<{ ok: boolean }>(`/user/${userId}/tier-override?id_passbook=${idPassbook}`, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
}
